import {
    enPeasantNames, enPeasantSurnames, enNobleNames, enNobleSurnames, enKnightTitles, enKnightEpithets,
    trPeasantNames, trPeasantSurnames, trNobleNames, trNobleTitles, trKnightNames, trKnightEpithets,
    frPeasantNames, frPeasantSurnames, frNobleNames, frNobleSurnames, frKnightTitles, frKnightEpithets,
    esPeasantNames, esPeasantSurnames, esNobleNames, esNobleSurnames, esKnightTitles, esKnightEpithets,
    dePeasantNames, dePeasantSurnames, deNobleNames, deNobleSurnames, deKnightTitles, deKnightEpithets,
    ptPeasantNames, ptPeasantSurnames, ptNobleNames, ptNobleSurnames, ptKnightTitles, ptKnightEpithets,
    arPeasantNames, arPeasantSurnames, arNobleNames, arNobleTitles, arKnightNames, arKnightEpithets,
    hiPeasantNames, hiPeasantSurnames, hiNobleNames, hiNobleTitles, hiKnightNames, hiKnightEpithets,
    jaPeasantNames, jaPeasantSurnames, jaNobleNames, jaNobleSurnames, jaKnightTitles, jaKnightEpithets,
    koPeasantNames, koPeasantSurnames, koNobleNames, koNobleSurnames, koKnightTitles, koKnightEpithets,
    idPeasantNames, idPeasantSurnames, idNobleNames, idNobleTitles, idKnightNames, idKnightEpithets,
    viPeasantNames, viPeasantSurnames, viNobleNames, viNobleTitles, viKnightNames, viKnightEpithets,
    ruPeasantNames, ruPeasantSurnames, ruNobleNames, ruNobleSurnames, ruKnightTitles, ruKnightEpithets,
    itPeasantNames, itPeasantSurnames, itNobleNames, itNobleSurnames, itKnightTitles, itKnightEpithets,
    plPeasantNames, plPeasantSurnames, plNobleNames, plNobleSurnames, plKnightTitles, plKnightEpithets,
    nlPeasantNames, nlPeasantSurnames, nlNobleNames, nlNobleSurnames, nlKnightTitles, nlKnightEpithets
} from '@/constants/medievalNames';

interface LocaleData {
    peasantNames: string[];
    peasantSurnames: string[];
    nobleNames: string[];
    nobleTitles: string[];
    nobleSurnames: string[];
    knightNames: string[];
    knightTitles: string[];
    knightEpithets: string[];
}

// Locales that use Title+Name style for nobles (like Ottoman/Eastern)
const titleBasedNobleLocales = ['tr', 'ar', 'hi', 'id', 'vi'];

const localeDataMap: Record<string, LocaleData> = {
    en: {
        peasantNames: enPeasantNames, peasantSurnames: enPeasantSurnames,
        nobleNames: enNobleNames, nobleTitles: [], nobleSurnames: enNobleSurnames,
        knightNames: enNobleNames, knightTitles: enKnightTitles, knightEpithets: enKnightEpithets
    },
    tr: {
        peasantNames: trPeasantNames, peasantSurnames: trPeasantSurnames,
        nobleNames: trNobleNames, nobleTitles: trNobleTitles, nobleSurnames: [],
        knightNames: trKnightNames, knightTitles: [], knightEpithets: trKnightEpithets
    },
    fr: {
        peasantNames: frPeasantNames, peasantSurnames: frPeasantSurnames,
        nobleNames: frNobleNames, nobleTitles: [], nobleSurnames: frNobleSurnames,
        knightNames: frNobleNames, knightTitles: frKnightTitles, knightEpithets: frKnightEpithets
    },
    es: {
        peasantNames: esPeasantNames, peasantSurnames: esPeasantSurnames,
        nobleNames: esNobleNames, nobleTitles: [], nobleSurnames: esNobleSurnames,
        knightNames: esNobleNames, knightTitles: esKnightTitles, knightEpithets: esKnightEpithets
    },
    de: {
        peasantNames: dePeasantNames, peasantSurnames: dePeasantSurnames,
        nobleNames: deNobleNames, nobleTitles: [], nobleSurnames: deNobleSurnames,
        knightNames: deNobleNames, knightTitles: deKnightTitles, knightEpithets: deKnightEpithets
    },
    pt: {
        peasantNames: ptPeasantNames, peasantSurnames: ptPeasantSurnames,
        nobleNames: ptNobleNames, nobleTitles: [], nobleSurnames: ptNobleSurnames,
        knightNames: ptNobleNames, knightTitles: ptKnightTitles, knightEpithets: ptKnightEpithets
    },
    ar: {
        peasantNames: arPeasantNames, peasantSurnames: arPeasantSurnames,
        nobleNames: arNobleNames, nobleTitles: arNobleTitles, nobleSurnames: [],
        knightNames: arKnightNames, knightTitles: [], knightEpithets: arKnightEpithets
    },
    hi: {
        peasantNames: hiPeasantNames, peasantSurnames: hiPeasantSurnames,
        nobleNames: hiNobleNames, nobleTitles: hiNobleTitles, nobleSurnames: [],
        knightNames: hiKnightNames, knightTitles: [], knightEpithets: hiKnightEpithets
    },
    ja: {
        peasantNames: jaPeasantNames, peasantSurnames: jaPeasantSurnames,
        nobleNames: jaNobleNames, nobleTitles: [], nobleSurnames: jaNobleSurnames,
        knightNames: jaNobleNames, knightTitles: jaKnightTitles, knightEpithets: jaKnightEpithets
    },
    ko: {
        peasantNames: koPeasantNames, peasantSurnames: koPeasantSurnames,
        nobleNames: koNobleNames, nobleTitles: [], nobleSurnames: koNobleSurnames,
        knightNames: koNobleNames, knightTitles: koKnightTitles, knightEpithets: koKnightEpithets
    },
    id: {
        peasantNames: idPeasantNames, peasantSurnames: idPeasantSurnames,
        nobleNames: idNobleNames, nobleTitles: idNobleTitles, nobleSurnames: [],
        knightNames: idKnightNames, knightTitles: [], knightEpithets: idKnightEpithets
    },
    vi: {
        peasantNames: viPeasantNames, peasantSurnames: viPeasantSurnames,
        nobleNames: viNobleNames, nobleTitles: viNobleTitles, nobleSurnames: [],
        knightNames: viKnightNames, knightTitles: [], knightEpithets: viKnightEpithets
    },
    ru: {
        peasantNames: ruPeasantNames, peasantSurnames: ruPeasantSurnames,
        nobleNames: ruNobleNames, nobleTitles: [], nobleSurnames: ruNobleSurnames,
        knightNames: ruNobleNames, knightTitles: ruKnightTitles, knightEpithets: ruKnightEpithets
    },
    it: {
        peasantNames: itPeasantNames, peasantSurnames: itPeasantSurnames,
        nobleNames: itNobleNames, nobleTitles: [], nobleSurnames: itNobleSurnames,
        knightNames: itNobleNames, knightTitles: itKnightTitles, knightEpithets: itKnightEpithets
    },
    pl: {
        peasantNames: plPeasantNames, peasantSurnames: plPeasantSurnames,
        nobleNames: plNobleNames, nobleTitles: [], nobleSurnames: plNobleSurnames,
        knightNames: plNobleNames, knightTitles: plKnightTitles, knightEpithets: plKnightEpithets
    },
    nl: {
        peasantNames: nlPeasantNames, peasantSurnames: nlPeasantSurnames,
        nobleNames: nlNobleNames, nobleTitles: [], nobleSurnames: nlNobleSurnames,
        knightNames: nlNobleNames, knightTitles: nlKnightTitles, knightEpithets: nlKnightEpithets
    }
};

export interface MedievalNameGeneratorOptions {
    count?: number;
    style?: 'peasant' | 'noble' | 'knight' | 'any';
    locale?: string;
}

export function generateMedievalNames(options: MedievalNameGeneratorOptions = {}): string[] {
    const count = options.count || 10;
    const style = options.style || 'any';
    const locale = options.locale || 'en';
    const names: string[] = [];

    const data = localeDataMap[locale] || localeDataMap['en'];
    const enData = localeDataMap['en'];

    for (let i = 0; i < count; i++) {
        let currentStyle = style;
        if (currentStyle === 'any') {
            const styles = ['peasant', 'noble', 'knight'];
            currentStyle = styles[Math.floor(Math.random() * styles.length)] as 'peasant' | 'noble' | 'knight';
        }

        let name = '';

        switch (currentStyle) {
            case 'peasant': {
                const firstName = data.peasantNames[Math.floor(Math.random() * data.peasantNames.length)];
                const surname = data.peasantSurnames.length > 0
                    ? data.peasantSurnames[Math.floor(Math.random() * data.peasantSurnames.length)]
                    : "";
                name = `${firstName} ${surname}`.trim();
                break;
            }
            case 'noble': {
                const firstName = data.nobleNames[Math.floor(Math.random() * data.nobleNames.length)];

                if (titleBasedNobleLocales.includes(locale) && data.nobleTitles.length > 0) {
                    // Eastern style: Name + Title (e.g. Orhan Bey)
                    const title = data.nobleTitles[Math.floor(Math.random() * data.nobleTitles.length)];
                    name = `${firstName} ${title}`;
                } else {
                    // Western style: Name + Surname (e.g. Edward Plantagenet)
                    const surname = data.nobleSurnames.length > 0
                        ? data.nobleSurnames[Math.floor(Math.random() * data.nobleSurnames.length)]
                        : enData.nobleSurnames[Math.floor(Math.random() * enData.nobleSurnames.length)];
                    name = `${firstName} ${surname}`;
                }
                break;
            }
            case 'knight': {
                if (titleBasedNobleLocales.includes(locale) && data.knightTitles.length === 0) {
                    // Eastern style: Name + Epithet (e.g. Tural Alp or Battal Gazi)
                    const kname = data.knightNames[Math.floor(Math.random() * data.knightNames.length)];
                    const epithet = data.knightEpithets[Math.floor(Math.random() * data.knightEpithets.length)];
                    name = `${kname} ${epithet}`;
                } else {
                    // Western: Title + Name + Epithet (optional) or Surname
                    const title = data.knightTitles[Math.floor(Math.random() * data.knightTitles.length)];
                    const kname = data.knightNames[Math.floor(Math.random() * data.knightNames.length)];

                    // 50% chance for Epithet vs Surname
                    if (Math.random() > 0.5) {
                        const surname = data.nobleSurnames.length > 0 ? data.nobleSurnames[Math.floor(Math.random() * data.nobleSurnames.length)] : enData.nobleSurnames[Math.floor(Math.random() * enData.nobleSurnames.length)];
                        name = `${title} ${kname} ${surname}`;
                    } else {
                        const epithet = data.knightEpithets[Math.floor(Math.random() * data.knightEpithets.length)];
                        name = `${title} ${kname} ${epithet}`;
                    }
                }
                break;
            }
        }

        names.push(name);
    }

    return names;
}
